<template>
  <div style="height: inherit">
    <yw-head></yw-head>
    <my-banner></my-banner>
    <left-nav active-name="milestone"></left-nav>
  </div>
</template>

<script>
  import banner from './bannerS';
  import leftNav from './leftNav';
  import yw_head from './yw_head';
  import yw_footer from './yw_footer';

  export default {
    name: "milestone",
    components: {
      'yw-head': yw_head,
      'yw-footer': yw_footer,
      'my-banner': banner,
      'left-nav': leftNav
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/milestone.vue